import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GeoService } from '../../services/geo.service';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {
  private geoService = inject(GeoService);
  private apiService = inject(ApiService);
  
  fullName = '';
  email = '';
  phone = '';
  message = '';
  
  isCountryDropdownOpen = false;

  countryCodes = [
    { code: '+1', country: 'US/CA', iso: 'US', placeholder: '202 555 0123' },
    { code: '+44', country: 'UK', iso: 'GB', placeholder: '7700 900077' },
    { code: '+20', country: 'Egypt', iso: 'EG', placeholder: '101 234 5678' },
    { code: '+966', country: 'Saudi Arabia', iso: 'SA', placeholder: '50 123 4567' },
    { code: '+971', country: 'UAE', iso: 'AE', placeholder: '50 123 4567' },
    { code: '+965', country: 'Kuwait', iso: 'KW', placeholder: '5123 4567' },
    { code: '+974', country: 'Qatar', iso: 'QA', placeholder: '3312 3456' },
    { code: '+973', country: 'Bahrain', iso: 'BH', placeholder: '3312 3456' },
    { code: '+968', country: 'Oman', iso: 'OM', placeholder: '9123 4567' },
    { code: '+962', country: 'Jordan', iso: 'JO', placeholder: '7 9123 4567' },
    { code: '+961', country: 'Lebanon', iso: 'LB', placeholder: '3 123 456' },
    { code: '+964', country: 'Iraq', iso: 'IQ', placeholder: '790 123 4567' },
    { code: '+963', country: 'Syria', iso: 'SY', placeholder: '93 123 4567' },
    { code: '+970', country: 'Palestine', iso: 'PS', placeholder: '59 123 4567' },
    { code: '+967', country: 'Yemen', iso: 'YE', placeholder: '71 123 4567' },
    { code: '+212', country: 'Morocco', iso: 'MA', placeholder: '612 345 678' },
    { code: '+213', country: 'Algeria', iso: 'DZ', placeholder: '551 23 45 67' },
    { code: '+216', country: 'Tunisia', iso: 'TN', placeholder: '98 123 456' },
    { code: '+218', country: 'Libya', iso: 'LY', placeholder: '91 123 4567' },
    { code: '+249', country: 'Sudan', iso: 'SD', placeholder: '91 234 5678' },
    { code: '+222', country: 'Mauritania', iso: 'MR', placeholder: '41 23 45 67' },
    { code: '+252', country: 'Somalia', iso: 'SO', placeholder: '61 234 5678' },
    { code: '+253', country: 'Djibouti', iso: 'DJ', placeholder: '77 12 34 56' },
    { code: '+269', country: 'Comoros', iso: 'KM', placeholder: '321 2345' }
  ];

  selectedCountry = this.countryCodes[0]; // Default +1 (US)

  ngOnInit() {
    this.detectCountry();
  }

  detectCountry() {
    this.geoService.getUserCountry().subscribe(isoCode => {
      if (isoCode) {
        const detected = this.countryCodes.find(c => c.iso === isoCode);
        if (detected) {
          this.selectedCountry = detected;
        }
      }
    });
  }

  toggleCountryDropdown() {
    this.isCountryDropdownOpen = !this.isCountryDropdownOpen;
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.isCountryDropdownOpen = false;
  }

  onSubmit(event: Event) {
    event.preventDefault();
    if (this.fullName && this.email && this.phone && this.message) {
      const contactData = {
        fullName: this.fullName,
        email: this.email,
        phone: this.selectedCountry.code + ' ' + this.phone,
        message: this.message
      };

      this.apiService.submitContact(contactData).subscribe({
        next: (res) => {
          console.log('Contact form successfully posted to CRM:', res);
          alert('Thank you for reaching out. A consultant will contact you shortly.');
          // Reset form
          this.fullName = '';
          this.email = '';
          this.phone = '';
          this.message = '';
        },
        error: (err) => {
          console.error('Failed to post contact query to CRM:', err);
          alert('Failed to submit message. Please check if CRM mock server is running.');
        }
      });
    }
  }
}
